import React from "react";

const FetchUsers = () => {
  return <div>fetch users</div>;
};

export default FetchUsers;
